import { UCSDKService } from "./ucf-sdk";

export const UCSDK = new UCSDKService();
